import { apiPost } from '../../api'

export const recruitment_setup = data => {
  return apiPost({
    endpoint: 'events/recruitment_setup',
    data: data
  })
}
